// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchHeader":"WU","sortWrapper":"XU","shortCount":"YU","fullCount":"ZU","countWrapper":"_U"};